import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { DatePicker } from 'antd';
import { MASCARA_DDMMYYYY, convertirTextAMomentUTC } from '../../commons/gestioDates';

const formatValor = 'YYYY-MM-DD';

class VariableData extends Component {

    render() {

        const { variable } = this.props;

        const dataSeleccionadaText = variable.valor;
        const dataSeleccionada = dataSeleccionadaText ? convertirTextAMomentUTC(dataSeleccionadaText, formatValor) : null;

        return (
            <div>
                {variable.nom}
                <DatePicker
                    defaultValue={dataSeleccionada}
                    onChange={(date) => this.props.onChangeValorVariable(date.format(formatValor))}
                    format={MASCARA_DDMMYYYY} />
            </div>
        );
    }
}

VariableData.propTypes = {
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func
};

export default VariableData;



// WEBPACK FOOTER //
// ./src/components/commons/variableData.js